export default __webpack_public_path__ + "img/green.a3f75682.png";